import CONFIG from '@js/config'
import utils from '@js/utils'

import '@js/app'
import scrollbar from '@js/scrollbar'

import '@comp/animate_title/animate_title'
import '@comp/animate_title/animate_title.scss'

import { resetForm, setMessage } from '@comp/form/form'
import '@comp/form/form.scss'

import compNote from '@comp/note/note.ejs'
import '@comp/note/note.scss'

import './style.scss'
import { trackEvent, trackSection } from '@/scripts/ga'

$(() => {
    trackSection('Contact')

    let contact = utils.getURLParam('contact') || 'service'

    const $tabLine = $('.tab-line')
    $('.form-tab-wrap').find('.form-tab').click(function () {
        $(this).addClass('actived').siblings().removeClass('actived')

        let translate = $(this).index() * 100
        contact = $(this).index() === 0 ? 'service' : 'media'

        $tabLine.css({
            'transform': `translateX(${translate}%)`
        })
    })

    if (contact === 'media') {
        $tabLine.css({
            'transform': `translateX(100%)`
        })
    }

    let noteList = [
        {
            bgUrl: false,
            title: 'New Business',
            desc: 'Reimagine your businesses through a multi-industry and cross-disciplinary lens.',
            linkUrl: 'mailto:info@6e-group.com',
            linkName: 'info@6e-group.com',
            track: 'Business Inquire'
        },
        {
            bgUrl: false,
            title: 'Media Inquires',
            desc: 'We’re happy to share insights and knowhow that intersects innovation, marketing, technology and business.',
            linkUrl: 'mailto:media@6e-group.com',
            linkName: 'media@6e-group.com',
            track: 'Media Inquire'
        },
        {
            bgUrl: false,
            title: 'Careers',
            desc: 'Join us here to enjoy incredible working experience.',
            linkUrl: 'mailto:talent@6e-group.com',
            linkName: 'talent@6e-group.com',
            track: 'Careers Apply'
        }
    ]

    let noteHtml = ''

    noteList.forEach((note) => {
        noteHtml += `
            <div class="contact-note">
            ${compNote(note)}
            </div>
        `
    })

    $('#right-note-wrap').html(noteHtml)

    $('#contact-submit-button').on('click', function () {
        let firstName = $('#first-name-field').val()
        let lastName = $('#last-name-field').val()
        let jobTitle = $('#job-title-field').val()
        let company = $('#company-field').val()
        let phoneNumber = $('#phone-number-field').val()
        let email = $('#email-field').val()
        let coverLetter = $('#cover-letter-field').val()

        setMessage()

        if (!firstName) {
            $('#first-name-field').parent().addClass('error')
            setMessage({ fail: 'Please enter your first name' })
            return
        }
        if (!lastName) {
            $('#last-name-field').parent().addClass('error')
            setMessage({ fail: 'Please enter your last name' })
            return
        }
        // if (!jobTitle) {
        //     $('#job-title-field').parent().addClass('error')
        //     return
        // }
        // if (!company) {
        //     $('#company-field').parent().addClass('error')
        //     return
        // }
        if (!phoneNumber || !utils.isPhone(phoneNumber)) {
            $('#phone-number-field').parent().addClass('error')
            setMessage({ fail: 'Please enter your phone number' })
            return
        }
        if (!email || !utils.isEmail(email)) {
            $('#email-field').parent().addClass('error')
            setMessage({ fail: 'Please enter your email' })
            return
        }
        // if (!coverLetter) {
        //     $('#cover-letter-field').parent().addClass('error')
        //     setMessage({ fail: 'Please enter your cover letter' })
        //     return
        // }
        trackEvent(`${utils.firstUpperCase(contact)} Inquire Apply`)
        $.ajax({
            type: 'POST',
            url: `${CONFIG.API_BASE}contact`,
            data: {
                company,
                email,
                first_name: firstName,
                last_name: lastName,
                job_title: jobTitle,
                phone: phoneNumber,
                cover_letter: coverLetter,
                type: contact
            },
            dataType: 'json',
            success: function (msg) {
                setMessage({ success: 'Your message was successfully sent' })
                resetForm()
            },
            error: function (err) {
                console.log(err)
                setMessage({ fail: 'Your message failed to send' })
            }
        })
    })

    scrollbar.init()
})
